
function CharitySvc($resource) {
    'ngInject';
    var odataUrl = TFL_Base_Url + 'organization/charity'
    return $resource(odataUrl, {}, {
        get: { method: 'GET', params: { Id: '@Id' }, isArray: false },
        member_set: { method: 'POST', params: { APIKey: '@APIKey', Id: '@Id' }, isArray: false }
    });
  };
  
  export default {
    name: "CharitySvc",
    fn: CharitySvc
  }